import DashboardNotificationCard from './DashboardNotificationCard';

export default DashboardNotificationCard;
